import { ColumnsWidths, RequestTableColumn, RowSettingItem } from '@core/types';

export const X_AUTH_SHOW_LOGIN = 'X_AUTH_SHOW_LOGIN';
export const X_TABLE_COLUMNS = 'X_TABLE_COLUMNS';
export const X_TABLE_COLUMNS_ORDER = 'X_TABLE_COLUMNS_ORDER';
export const X_TABLE_COLUMNS_WIDTHS = 'X_TABLE_COLUMNS_WIDTHS';
export const X_TABLE_ROWS_SETTINGS = 'X_TABLE_ROWS_SETTINGS';
export const X_TABLE_ROWS_PER_PAGE = 'X_TABLE_ROWS_PER_PAGE';
export const X_REQUEST_TYPE_ID = 'x-request-type-id';
export const CURRENT_USER_LOCAL_STORAGE = 'current_user';
export const REQUEST_LIST_STATE_KEY = 'request_list_state:allRequests';
export const HIDE_COMPLETED_FILTER = 'hide_completed_filter';
export const SHOW_IN_WORK_FILTER = 'show_in_work_filter';
export const SHOW_TODAY_FILTER = 'show_today_filter';
export const SHOW_TOMORROW_FILTER = 'show_tomorrow_filter';
export const REQUEST_STATUSES_TRANSLATION_KEY = 'request_statuses';
export const REQUEST_OBD_STATUSES_TRANSLATION_KEY = 'obd_statuses';
export const OBD_STATUS_FILTER_BUTTON_TRANSLATION_KEY = 'obdStatus';
export const REQUEST_OBD_SUCCESS_READ_TRANSLATION_KEY = 'obd_success_read';
export const PREFERRED_LANG_LOCAL_STORAGE = 'preferred_lang';
export const REQUEST_QUALITY_STATUSES_TRANSLATION_KEY = 'quality_statuses';
export const DEFAULT_CONTRACTOR_COUNTERPARTY_ID = 1;
export const MOBILE_REQUESTS_LIST_COMPACT_MODE =
  'mobile_requests_list_compact_mode';
export const INITIAL_DESKTOP_COLUMNS: RequestTableColumn[] = [
  'requestNumber',
  'releaseTime',
  'releaseDate',
  'releaseDatePeriod',
  'contract',
  'car',
  'carPlantNumber',
  'vin',
  'projectNumber',
  'subjName',
  'deliveryAddress',
  'counterPartyName',
  'products',
  'installerShort',
  'statusId',
  'deliveryName',
  'createdAt',
  'updatedAt',
  'qualityControlStatus',
  'docs',
];

export const INITIAL_DESKTOP_COLUMNS_WIDTH: ColumnsWidths = {
  requestNumber: 140,
  releaseTime: 160,
  releaseDate: 140,
  releaseDatePeriod: 228,
  contract: 160,
  car: 180,
  carPlantNumber: 156,
  vin: 156,
  projectNumber: 158,
  subjName: 175,
  deliveryAddress: 300,
  counterPartyName: 190,
  products: 150,
  installerShort: 260,
  statusId: 170,
  deliveryName: 150,
  createdAt: 150,
  updatedAt: 157,
  qualityControlStatus: 150,
  docs: 240,
};

export const INITIAL_DESKTOP_ROWS_PER_PAGE = 10;

export const INITIAL_DESKTOP_ROWS_SETTINGS: RowSettingItem[] = [
  { key: 'rowBgColorStatus', value: false },
];
export const TUI_THEME_DEFAULT_KEY = 'theme';

// IndexedDB constants
export const INDEXED_DB_NAME = 'OutkeepDB';
export const INDEXED_DB_STORE_NAME = 'outkeepStore';
